import { useLocalization } from '@/data/Localization';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { Box, Link, Typography } from '@mui/material';
import { FC } from 'react';
import { styles } from '../styles/style';

interface DownloadItemProps {
	name: string;
	url: string;
	id: string;
}

export const DownloadItem: FC<DownloadItemProps> = ({ name, url, id }) => {
	const { download } = useLocalization('HDMProductDetail');
	return (
		<Box sx={styles.downloadableItem}>
			<Link href={url} sx={styles.downloadLink} target="_blank" rel="noopener noreferrer" id={id}>
				<Box sx={styles.downloadContent}>
					<InsertDriveFileOutlinedIcon sx={styles.fileIcon} />
					<Typography sx={styles.fileName}>{name}</Typography>
				</Box>
				<Box sx={styles.downloadAction}>
					<FileDownloadOutlinedIcon sx={styles.downloadIcon} />
					<Typography sx={styles.downloadText}>{download.t()}</Typography>
				</Box>
			</Link>
		</Box>
	);
};
